"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setError = exports.setLoadingState = exports.setWidgetDefaults = exports.setConfig = exports.localeSelector = exports.systemSelector = exports.headersSelector = exports.globalsSelector = exports.errorSelector = exports.loadingStateSelector = exports.widgetDefaultsSelector = exports.scenesCacheSelector = exports.widgetsCacheSelector = exports.edgeScenesSelector = exports.configSelector = exports.reducer = exports.setModulePath = void 0;
var get = require("lodash/get");
var isEqual = require("lodash/isEqual");
var createLoggers_1 = require("../util/createLoggers");
var edgeConfigModuleTypes_1 = require("./edgeConfigModuleTypes");
// For backward compatibility, types were here previously
__exportStar(require("./edgeConfigModuleTypes"), exports);
var debug = (0, createLoggers_1.createLoggers)('edgeConfigModule').debug;
var defaultState = {
    config: null,
    scenes: [],
    widgetsCache: {},
    widgetDefaults: {},
    loadingState: edgeConfigModuleTypes_1.EdgeConfigLoadingStates.INITIAL,
    scenesCache: {},
};
var modulePath = '';
function setModulePath(path) {
    modulePath = path;
}
exports.setModulePath = setModulePath;
var supportsPerformance = typeof performance === 'object';
var now = function () {
    if (supportsPerformance) {
        return performance.now();
    }
    return Date.now();
};
/**
 * Merge 2 by Key objects
 * { [key: string]: object }
 *
 * Merge values from 2nd to first, only if
 * key is new
 * value has different state (deep equal)
 */
var mergeKeyByOnlyIfChanged = function (prev, update) {
    var compareStart = now();
    var keysWillBe = Object.keys(update);
    var newKeys = keysWillBe.filter(function (key) { return !prev[key]; });
    var changedWidgets = keysWillBe.filter(function (key) { return !!prev[key] && !isEqual(prev[key], update[key]); });
    var updateKeys = newKeys.concat(changedWidgets);
    var updateObjects = updateKeys.reduce(function (memo, key) {
        memo[key] = update[key];
        return memo;
    }, {});
    var newWidgetsCache = __assign(__assign({}, prev), updateObjects);
    var took = (now() - compareStart).toFixed(2);
    return [newWidgetsCache, ["updateKeys " + updateKeys.join(), "compare took " + took + "ms"]];
};
/**
 * Payload here is normalized edgeConfig
 */
var getNewScenesCache = function (previousScenesCache, edgeConfig) {
    var scenesByKey = edgeConfig.scenesData.reduce(function (m, model) {
        m[model.type] = model;
        return m;
    }, {});
    var _a = mergeKeyByOnlyIfChanged(previousScenesCache, scenesByKey), update = _a[0], logs = _a[1];
    logs.forEach(function (l) { return debug('[getNewScenesCache]', l); });
    return update;
};
var getNewWidgetsCache = function (previousWidgetsCache, _a) {
    var widgets = _a.widgets;
    var _b = mergeKeyByOnlyIfChanged(previousWidgetsCache, widgets), update = _b[0], logs = _b[1];
    logs.forEach(function (l) { return debug('[getNewWidgetsCache]', l); });
    return update;
};
function reducer(state, action) {
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case edgeConfigModuleTypes_1.Actions.configChange: {
            if (typeof window === 'object') {
                window.config = action.payload;
            }
            var newWidgetsCache = getNewWidgetsCache(state.widgetsCache, action.payload);
            var newScenesCache = getNewScenesCache(state.scenesCache, action.payload);
            return __assign(__assign({}, state), { config: __assign(__assign({}, action.payload), { children: [], widgets: [], scenes: [] }), scenes: __spreadArray([], action.payload.scenes, true), widgetsCache: newWidgetsCache, scenesCache: newScenesCache });
        }
        case edgeConfigModuleTypes_1.Actions.configLoadingChange: {
            return __assign(__assign({}, state), { loadingState: action.payload });
        }
        case edgeConfigModuleTypes_1.Actions.widgetDefaults: {
            return __assign(__assign({}, state), { widgetDefaults: action.payload });
        }
        case edgeConfigModuleTypes_1.Actions.loadingError: {
            return __assign(__assign({}, state), { error: action.payload });
        }
        default: {
            return state;
        }
    }
}
exports.reducer = reducer;
var getLocalState = function (state) { return get(state, modulePath, defaultState); };
var configSelector = function (state) { return getLocalState(state).config; };
exports.configSelector = configSelector;
var edgeScenesSelector = function (state) { return getLocalState(state).scenes; };
exports.edgeScenesSelector = edgeScenesSelector;
var widgetsCacheSelector = function (state) { return getLocalState(state).widgetsCache; };
exports.widgetsCacheSelector = widgetsCacheSelector;
var scenesCacheSelector = function (state) { return getLocalState(state).scenesCache; };
exports.scenesCacheSelector = scenesCacheSelector;
var widgetDefaultsSelector = function (state) { return getLocalState(state).widgetDefaults; };
exports.widgetDefaultsSelector = widgetDefaultsSelector;
var loadingStateSelector = function (state) { return getLocalState(state).loadingState; };
exports.loadingStateSelector = loadingStateSelector;
var errorSelector = function (state) { return getLocalState(state).error; };
exports.errorSelector = errorSelector;
var globalsSelector = function (state) { return get((0, exports.configSelector)(state), 'globals'); };
exports.globalsSelector = globalsSelector;
var headersSelector = function (state) {
    return get((0, exports.configSelector)(state), 'globals.headers', {});
};
exports.headersSelector = headersSelector;
var systemSelector = function (state) { return get((0, exports.configSelector)(state), 'globals.system'); };
exports.systemSelector = systemSelector;
var localeSelector = function (state) {
    var config = (0, exports.configSelector)(state);
    var languagId = get(config, 'globals.headers.language_id', '1');
    var analyticsLanguageCode = get(config, 'globals.analytics.locale', 'en');
    var languageCode = get(config, 'htmlAttributes.lang', analyticsLanguageCode);
    return {
        id: parseInt(languagId, 10),
        code: languageCode,
    };
};
exports.localeSelector = localeSelector;
var setConfig = function (config) { return ({
    type: edgeConfigModuleTypes_1.Actions.configChange,
    payload: config,
}); };
exports.setConfig = setConfig;
var setWidgetDefaults = function (widgetDefaults) { return ({
    type: edgeConfigModuleTypes_1.Actions.widgetDefaults,
    payload: widgetDefaults,
}); };
exports.setWidgetDefaults = setWidgetDefaults;
var setLoadingState = function (state) { return ({
    type: edgeConfigModuleTypes_1.Actions.configLoadingChange,
    payload: state,
}); };
exports.setLoadingState = setLoadingState;
var setError = function (error) { return ({
    type: edgeConfigModuleTypes_1.Actions.loadingError,
    payload: error,
}); };
exports.setError = setError;
